import styled from '@emotion/styled';
import { Alert, Button, Result, Space } from 'antd';
import { useOrgValue } from 'hooks/business/system/useOrg';
import { useTranslate } from '@tolgee/react';
import { BootGuideAuthTip, GotoBootGuideButton } from 'views/BootGuide/components/GuideLink';
import { isMasterOnline, isSiteGiant } from '../../../productLine';

export interface SuccessResultProps {
  isConfigService?: boolean;
  onRestart: () => any;
  onFinish: (redirect?: string) => any;
  onConfigService?: (e: any) => void;
  count?: number;
}

const Footer = styled.div`
  text-align: center;
`;
const MiniAlert = styled(Alert)`
  box-sizing: border-box;
  padding: 4px 10px;
  max-width: 70%;
  font-size: 14px;
  margin: 0 auto 12px auto;
`;
const SuccessResult = (props: SuccessResultProps) => {
  const { onRestart, onFinish, count } = props;
  const { t } = useTranslate();
  const orgValue = useOrgValue();
  const isExpired = orgValue?.isExpired;

  return (
    <>
      <Result
        status="success"
        title={t('authShop.已经成功添加个店铺', { count })}
        extra={t('authShop.添加更多店铺')}
      />
      <Footer>
        <MiniAlert
          type="warning"
          showIcon
          message={t('authShop.首次添加店铺完成后需等待15分钟，系统自动同步消息内容及订单信息')}
        />
        <BootGuideAuthTip className="mb-[26px] mt-[16px]" />
        <Space>
          {isExpired ? (
            isSiteGiant || isMasterOnline ? null : (
              <Button type="primary" onClick={() => onFinish('/management/service/market')}>
                {t('shop_auth_result_goto_order_package')}
              </Button>
            )
          ) : (
            <GotoBootGuideButton
              onClick={() => onFinish()}
              fallback={
                <Button type="primary" onClick={() => onFinish('/conversation')}>
                  {t('authShop.立即开始接待')}
                </Button>
              }
            />
          )}
          <Button onClick={onRestart}>{t('authShop.再次添加新的店铺')}</Button>
        </Space>
      </Footer>
    </>
  );
};
export default SuccessResult;
